import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { LdsRing } from './loader.component.styled';

const Loader: React.FC<Props> = ({}) => {
  return (
    <div className="text-center" role="progressbar">
      <LdsRing>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </LdsRing>
    </div>
  );
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Loader);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
